import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../actions/commonActions";
import { FETCH_SELF_FINANCIALS_FAILURE, FETCH_SELF_FINANCIALS_REQUEST, FETCH_SELF_FINANCIALS_SUCCESS } from "../actions/selfFinancialsActions";

  const initialState = {
    records: [],
    recordsLoading: true,
    recordsError: null,
  };
  
  const selfFinancialsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SELF_FINANCIALS_REQUEST:
        return { ...state, recordsLoading: true , payload: action.payload};
      case FETCH_SELF_FINANCIALS_SUCCESS:
        return { ...state, recordsLoading: false, records: action.payload };
      case FETCH_SELF_FINANCIALS_FAILURE:
        return { ...state, recordsLoading: false, recordsError: action.payload };
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
        return  { ...state, recordsLoading: false, records: [] };
      default:
        return state;
    }
  };
  
  export default selfFinancialsReducer;
  